module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.10659/js/img/ContentHub_Icon.svg"